export default {
  searchNoAvailableRoomsMessage: '19122018-152801-0008',
  searchAdjustSearchParamsMessage: '19122018-152801-0009',
  searchAdjustDayTimeOrCallUsMessage: '05112020-131733-3063',
  searchUnavailableRoomsSelectedRoomHeader: '22022019-142905-0001',
  searchUnavailableRoomsWarningSubheader: '19122018-152801-0010',
  searchUnavailableRoomsRevealLabel: '19122018-152801-0007',
  searchUnavailableRoomsExpandControlLabel: '19122018-152801-0007',
  searchUnavailableRoomsCollapseControlLabel: '22022019-142905-0002',
  searchUnavailableRoomsFurther: '19122018-152801-0013',
  searchSortByLabel: '23082016-151743-4917',
  searchShowAllLabel: '16112016-085025-9286',
  searchShowNextLabel: '19122018-152801-0018',
  searchChosenLocationLabel: '22022019-142905-0001',
  searchOtherCenteresLabel: '22022019-142905-0001',
  searchResultsFoundLabel: '22022019-142905-0003',
  searchResultsFoundWithAreaLabel: '19122018-152801-0016',
  searchTopRoomsShownLabel: '19122018-152801-0015',

  roomSortingByDistanceLabel: '02092015-124256-4784',
  roomSortingByPopularityLabel: '04122017-151239-4542',
  roomSortingByPriceDescendingLabel: '17022017-161648-6169',
  roomSortingByPriceAscendingLabel: '17022017-161218-5312',
  revealUnavailableCentres: '22072019-155148-8122',
  loadMoreLocations: '13122023-102534-0012',
  clearFilters: '29012020-152859-0033',

  noResultsForYourSearchWereFound: '29012020-152859-0011',
  expandSearchArea: '07052026-100417-2595',
  otherOptionsAvailable: '20052026-093454-8689',
  lookingForMoreOptions: '20052026-093454-8690'
};
